module.exports = __webpack_public_path__ + "img/google.20234ea8.png";